import { Component, OnInit, ViewChild, HostListener, ElementRef, Input } from '@angular/core';
import { PanelPropuestasComponent } from '../../../components/propuestas/panel-propuestas/panel-propuestas.component';
import { DashboardComponent } from '../../../components/dashboard/dashboard.component';
import { AgendaComponent } from '../../../components/agenda/agenda.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public panel: string;
  public mostrarAyuda: boolean = false;
  @Input() tooltipDir: string = 'right';

  @ViewChild('panelPropuestas') panelPropuestas: PanelPropuestasComponent;
  @ViewChild('estadisticas') estadisticas: DashboardComponent;
  @ViewChild('agenda') agenda: AgendaComponent;

  constructor(

  ) { }

  ngOnInit(): void {
    this.panel = 'tablero';
  }
  cerrarAyuda() {
    this.mostrarAyuda = false;
  }

}